/**
 * Client-side first-pass safety classifier (mirrors API safety.ts).
 * Crisis content is handled locally so users get help even if API is slow/offline.
 */

import { t } from "@/i18n";

export type SafetyLevel = "normal" | "elevated" | "crisis";

const CRISIS_PATTERNS = [
  /suicid/i,
  /ta livet/i,
  /döda mig/i,
  /vill inte leva/i,
  /kill myself/i,
  /end my life/i,
  /självmord/i,
];

const ELEVATED_PATTERNS = [
  /hopplös/i,
  /ingen utväg/i,
  /skada mig/i,
  /self[- ]?harm/i,
  /panikattack/i,
];

export function classifySafety(text: string): {
  level: SafetyLevel;
  category: string | null;
} {
  for (const pattern of CRISIS_PATTERNS) {
    if (pattern.test(text)) {
      return { level: "crisis", category: "self_harm_crisis" };
    }
  }
  for (const pattern of ELEVATED_PATTERNS) {
    if (pattern.test(text)) {
      return { level: "elevated", category: "distress" };
    }
  }
  return { level: "normal", category: null };
}

export function crisisResponse(): string {
  return t("safety.crisis");
}

export function elevatedResponse(): string {
  return t("safety.elevated");
}
